import {Brand} from '../Brand';
import {chatCoffeeBase} from './chatCoffeeBase';
import {ChatCoffeeLogo} from './ChatCoffeeLogo';

export const chatCoffee: Brand = {
  ...chatCoffeeBase,
  assets: {
    logo: ChatCoffeeLogo,
  },
};
